import jQuery from 'jquery';
import _ from 'underscore';

import template from './template.html';

function MergeAttributionsTableDirective($timeout) {
  return {
    restrict: 'E',
    scope: {
      attributions: '=',
      selectedProperties: '='
    },
    replace: true,
    template,
    controller: 'mergeAttributionsTableCtrl',
    link: function (scope, element) {
      let alreadyBoundClickHandlers = false;

      scope.$watchCollection('attributions', () => {
        if (alreadyBoundClickHandlers) return;

        $timeout(() => {
          _bindClickHandlers();
        });
      });

      function _bindClickHandlers() {
        alreadyBoundClickHandlers = true;

        element.find('tbody tr').first().find('td.selectable').addClass('selected');

        element.find('.selectable').click(function () {
          const $element = jQuery(this);

          const attributionId = $element.attr('data-id');

          const attribution = _.findWhere(scope.attributions, {
            id: attributionId
          });

          if (!attribution) return null;

          const dataType = $element.attr('data-type');

          const thisClass = `.${dataType}`;

          jQuery(thisClass).removeClass('selected');

          $element.addClass('selected');

          scope.selectedProperties[dataType] = attribution[dataType];

          return false;
        });
      }
    }
  };
}

MergeAttributionsTableDirective.$inject = [
  '$timeout'
];

export default MergeAttributionsTableDirective;



// WEBPACK FOOTER //
// ./src/directives/mergeAttributionsTable/index.js